import { useTranslation } from "react-i18next";

export const ProductReportsTableItem = ({ item, index }) => {
    const [t] = useTranslation('global');
    const currentLang = 'ar'; // يمكن تحديث هذا لاستخدام اللغة الحالية من الترجمة
  
    const getCategoryName = (product) => {
      if (product?.productCategory?.length) {
        const category = product.productCategory[0];
        return category.categoryName?.find(item => item.lang === currentLang)?.text || 
               category.categoryName?.find(item => item.lang === 'en')?.text || 
               category.categoryName?.[0]?.text || '-';
      }
      return '-';
    };
  
    return (
      <div className="grid grid-cols-12 gap-3 border-t px-2 py-2 cursor-pointer items-center hover:bg-[#251658]/5 hover:font-bold">
        <div className="text-center col-span-1 text-[#251658] text-xs">
          {index+1}
        </div>
        <div className="text-center col-span-1 text-[#251658] text-xs">
          {item.productCode || '-'}
        </div>
        <div className="text-center col-span-2 text-[#251658] text-xs">
          {item.productName || '-'}
        </div>
        <div className="text-center col-span-3 text-[#251658] text-xs">
         </div>
        <div className="text-center col-span-2 text-[#251658] text-xs">
          {item.price ? `${item.price.toLocaleString()} ` : '-'}
        </div>
        <div className="text-center col-span-1 text-[#251658] text-xs">
          {item.qty || '-'}
        </div>
        <div className="text-center col-span-2 text-[#251658] text-xs">
          {getCategoryName(item)}
        </div>
      </div>
    );
  };
  